export const CALCULATORS_LAMINATE_OPEN_CONFIGURATION_EVENT = 'calculators:openConfigurationDrawer';
export const CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT = 'calculators:closeConfigurationDrawer';
export const DEFAULT_ROOM_TYPE = 'Комната';
export const DEFAULT_IMAGES_COUNT = 2;

export enum ScrollDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum CardWidth {
  DESKTOP = 380,
  LAPTOP = 300,
  MOBILE = 288,
}

export const IMAGES_COUNT_BY_WIDTH = {
  [CardWidth.DESKTOP]: 4,
  [CardWidth.LAPTOP]: 3,
  [CardWidth.MOBILE]: 2,
} as const;
